export const success = {
    PRODUCT_CREATED: {
        title: 'Produit créé avec succès',
        message: 'Votre produit sera visible une fois validé par un administrateur',
    },
    PRODUCT_UPDATED: {
        title: 'Produit mis à jour avec succès',
        message: 'Votre produit sera visible une fois validé par un administrateur',
    },
    ORDER_CREATED: {
        title: 'Commande créée avec succès',
        message: 'Commande créée avec succès',
    },
    ORDER_CANCELLED: {
        title: 'Commande annulée avec succès',
        message: 'Commande annulée avec succès',
    },
    ORDER_CONFIRMED: {
        title: 'Commande confirmée avec succès',
        message: 'Commande confirmée avec succès',
    },
    ORDER_PAYED: {
        title: 'Commande payée avec succès',
        message: 'Commande payée avec succès',
    },
    ORDER_SHIPPED: {
        title: 'Commande envoyée avec succès',
        message: 'Commande envoyée avec succès',
    },
    ORDER_DELIVERED: {
        title: 'Commande livrée avec succès',
        message: 'Commande livrée avec succès',
    },
    ORDER_RETURNED: {
        title: 'Commande retournée avec succès',
        message: 'Commande retournée avec succès',
    },
    ACCOUNT_EMAIL_VERIFIED: {
        title: 'Votre email a été vérifié avec succès',
        message: 'Vous pouvez maintenant vous connecter avec votre email',
    },
}